import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const deleteOKRApi = ({ id, archiveTree = true, permanentlyDelete = false }) => {
  const url = endpoints.rabbitGoals.deleteOKR(id);
  return sendRequest({
    method: 'DELETE',
    url,
    queryParams: {
      archiveTree,
      permanentlyDelete,
    },
    credentials: 'include',
  });
};

export const useDeleteOKRMutation = (uuid, permanentlyDelete = false) =>
  useMutation({
    mutationFn: async () =>
      deleteOKRApi({
        id: uuid,
        permanentlyDelete,
      }),
  });
